import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { COLORS, Cls_MobiTab } from "../models";

type position = "left" | "right";
type TAB_STYLE = "bordered" | "bordered-highlight" | "bordered-highlight-round" | "highlight-round";

@Component({
  selector: "mobi-office-lib-tabs",
  templateUrl: "./tabs.component.html",
  styleUrls: ["./tabs.component.scss"],
  standalone: false,
})
export class TabsComponent implements OnInit, OnChanges, OnDestroy {
  ngOnInit(): void {
    this.handler = function () {
      this.resizeEvent();
    };
  }

  ngOnChanges(): void {
    setTimeout(() => {
      this.resizeEvent();
    }, 0);
  }

  @Input() tabs: Cls_MobiTab[] = [];
  @Input() isDeletable: boolean = false;
  @Input() tabColor: COLORS = "primary";
  @Input() tabStyle: TAB_STYLE = "bordered-highlight";
  @Input() selectedTab: string | number = 0;

  // ICON
  @Input() iconClass: string = "";
  @Input() iconAlt: string = "tab-icon";
  @Input() iconPosition: position = "left";

  // Badge
  @Input() badgeClass?: string = "";
  @Input() badgePosition: position = "right";

  // Delete ICON
  @Input() deleteIconPath?: string = "global-assets/mobi-office-ui/close.svg";
  @Input() deleteIconClass?: string;
  @Input() deleteIconAlt?: string = "delete-icon";
  @Input() deleteIconPosition?: position = "right";
  @Input() deleteIconToolTip: string = "";

  @Output() selectedTabChange = new EventEmitter();
  @Output() tabChange = new EventEmitter();
  @Output() iconEmitter = new EventEmitter();
  @Output() deleteEmitter = new EventEmitter();

  @ViewChild("mainTabContainer")
  mainTabContainer!: ElementRef<HTMLDivElement>;
  @ViewChild("tabsContent", { read: ElementRef })
  public tabsContent!: ElementRef<HTMLDivElement>;
  isArrowVisible: boolean = false;

  @HostListener("window:resize", ["$event"])
  handler(): void {}

  onTabChange(tab: Cls_MobiTab) {
    if (tab.tabValue === this.selectedTab) return;
    this.selectedTab = tab.tabValue;
    this.selectedTabChange.emit(tab.tabValue);
    this.tabChange.emit(tab);
  }

  onIcon(tab: Cls_MobiTab, $event: Event) {
    this.iconEmitter.emit(tab);
    $event?.stopPropagation();
  }

  onDelete(index: number, $event: Event) {
    const deletedTab = structuredClone(this.tabs[index]);
    this.deleteEmitter.emit(deletedTab);
    // if (deletedTab.tabValue === this.selectedTab) {
    //   this.onTabChange(this.tabs[0]);
    // }

    $event?.stopPropagation();
  }

  scrollRight(): void {
    this.tabsContent.nativeElement.scrollTo({
      left: this.tabsContent.nativeElement.scrollLeft + 200,
      behavior: "smooth",
    });
  }

  scrollLeft(): void {
    this.tabsContent.nativeElement.scrollTo({
      left: this.tabsContent.nativeElement.scrollLeft - 200,
      behavior: "smooth",
    });
  }

  resizeEvent() {
    const div = this.tabsContent?.nativeElement;
    const tabs = this.mainTabContainer?.nativeElement.querySelectorAll(".arrow-icon") as NodeListOf<HTMLElement>;
    tabs?.forEach(element => {
      const isArrowVisible = div?.scrollWidth > div?.clientWidth;
      if (isArrowVisible) {
        element?.classList.remove("d-none");
      } else {
        element?.classList.add("d-none");
      }
    });
  }

  ngOnDestroy(): void {
    this.handler = function (): void {};
  }
}
